<script setup lang="ts">
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';

import { brandConfig } from '@/brand';

const carouselImgs = brandConfig.carouselImages;
</script>

<template>
  <div :class="$style.homePageCarousel" data-testid="homePageCarousel">
    <Carousel
      :class="$style.carousel"
      :autoplay="6000"
      :items-to-show="3.046"
      :wrap-around="true"
    >
      <Slide v-for="(img, index) in carouselImgs" :key="index">
        <v-sheet :class="$style.carouselItem" :elevation="1">
          <img :src="img" />
        </v-sheet>
      </Slide>

      <template #addons>
        <Navigation />
        <Pagination />
      </template>
    </Carousel>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use 'sass:color';
@use '@/styles/colors';
@use '@/styles/variables';

.homePageCarousel {
  :global {
    .carousel__prev,
    .carousel__next {
      background-color: color.adjust(colors.$color-brand-950, $alpha: -0.65);
      color: colors.$color-white;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      opacity: 0;
      transition: opacity 0.1s ease-out;
    }
    .carousel__pagination {
      margin-top: 5px;
    }
    .carousel__pagination-button::after {
      width: 15px;
      height: 3px;
      background-color: colors.$color-brand-100;
    }
    .carousel__pagination-button--active::after {
      background-color: colors.$color-brand-300;
    }
    .carousel__slide:not(.carousel__slide--next):not(.carousel__slide--prev):not(.carousel__slide--active) > div {
      box-shadow: none !important;
    }
  }
}
.homePageCarousel:hover {
  :global {
    .carousel__prev,
    .carousel__next {
      opacity: 1;
    }
  }
}

  .carousel {
    margin: -5px 0;
  }

    .carouselItem {
      overflow: hidden;
      width: 472px;
      height: 280px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 12px 5px 12px;

      & > img {
        display: block;
        width: 100%;
      }
    }
</style>
